import * as angular from 'angular';
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {ServiceValidationTemplateModel} from "../../models/service-validation-template.model";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";
import {PricePlanBundleService} from "../../services/price-plan-bundle.service";

export class ProgramAgentValidationsViewComponent implements IController {

  program: any;
  groups: any;
  programId: any;
  accountId: any;
  siteServiceValidations: ServiceValidationTemplateModel[];

  public groupValueCopy: any;
  public tabs: any;
  public allTemplates: any;
  public templates: any;
  public selectedTab: any;
  public groupValue: any;
  public templateValueMap: any;
  public isSaveAvailable: any;

  constructor(private PricePlanService, private $log, private pricePlanDialogService: PricePlanDialogService, private pricePlanBundleService: PricePlanBundleService) {
  }

  $onInit() {
    this._setGroupValue();
  }


  onAddValidation($event) {
    const templateIds = _.map(this.groupValue, 'id');
    this.pricePlanDialogService.selectServiceValidation(this.siteServiceValidations, templateIds, $event)
      .then((selectedIds) => {
        const values = this.pricePlanBundleService.getServiceValidationsGroupsByIds(selectedIds);
        this.groupValue = this.groupValue.concat(values);
        this.onSaveProgram();
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }


  onDelete(serviceValidation) {
    this.groupValue = _.filter(this.groupValue, (v) => {
      return v.id !== serviceValidation.id;
    })
    this.onSaveProgram();
  }

  onReset(serviceValidation) {
    const serviceValidationValueRef = _.find(this.groupValue, (v) => {
      return v.id === serviceValidation.id;
    })
    serviceValidationValueRef.value = undefined;
    this.templateValueMap = _.keyBy(this.groupValue, 'id');
    this._onDataChange();
  }

  onStateChange(isEnabled, isDefault, serviceValidationId) {
    const serviceValidationValueRef = _.find(this.groupValue, (v) => {
      return v.id === serviceValidationId;
    })
    if (serviceValidationValueRef) {

      if (!serviceValidationValueRef.value) {
        serviceValidationValueRef.value = {};
      }

      serviceValidationValueRef.value.id = serviceValidationId;
      serviceValidationValueRef.value.isEnabled = isEnabled;
      serviceValidationValueRef.value.isDefault = isDefault;
    }
    this.templateValueMap = _.keyBy(this.groupValue, 'id');
    this._onDataChange();
  }

  onChangeEnabledPurposes(enabledPurpose, serviceValidationId) {
    const serviceValidationValueRef = _.find(this.groupValue, (v) => {
      return v.id === serviceValidationId;
    })
    if (!serviceValidationValueRef.value) {
      serviceValidationValueRef.value = {};
    }
    if (serviceValidationValueRef) {
      serviceValidationValueRef.value.enabledTaskPurpose = enabledPurpose;
    }
    this.templateValueMap = _.keyBy(this.groupValue, 'id');
    this._onDataChange();
  }

  onSaveProgram() {
    const editedProgram = angular.copy(this.program);
    editedProgram.data[0].value = this.groupValue;

    this.PricePlanService.saveProgramDataByGroups(this.programId, editedProgram, this.groups, this.accountId)
      .then((updatedProgram) => {
        this.program = updatedProgram;
        this._setGroupValue();
      })
      .catch((error) => {
        this.$log.error('Failed to update program', error)
      })
      .finally(() => {
        this._setGroupValue();
      })
  }

  onCancelChanges() {
    this._setGroupValue();
  }

  private _setGroupValue() {
    this.isSaveAvailable = false;
    this.groupValue = angular.copy(this.program.data[0].value);
    this.groupValueCopy = angular.copy(this.program.data[0].value);
    this.templateValueMap = _.keyBy(this.groupValue, 'id');
    const programTemplateIds = this.groupValue.map(item => item.id);

    const templates = this.siteServiceValidations.filter(item => !!programTemplateIds.includes(item.id));
    this.templates = programTemplateIds.map((id) => {
      return templates.find((siteValidation) => {
        return siteValidation.id === id;
      })
    });
  }

  private _onDataChange() {
    this.isSaveAvailable = !_.isEqual(this.groupValue, this.groupValueCopy);
  }


}

angular
  .module('bringoz.admin.pricePlan')
  .component('programAgentValidationsView', {
    bindings: {
      program: '<',
      groups: '<',
      programId: '<',
      accountId: '<?',
      siteServiceValidations: '<?'
    },
    template: require('./program-agent-validations-view.html').default,
    controller: ProgramAgentValidationsViewComponent
  });
